import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getRandomApikey = createAsyncThunk('apiSetttings/getRandomApikey', async () => {
  const response = await axios.get(`RandomKey/getrandomapikey`);
  return response.data;
});

export const getGenerateApikeys = createAsyncThunk('apiSetttings/getGenerateApikeys', async () => {
  const response = await axios.get(`RandomKey/generate-apikeys`);
  return response.data;
});

export const createRandomApikey = createAsyncThunk('apiSetttings/createRandomApikey', async (value) => {
  try {
    const response = await axios.post(`RandomKey/createrandomapikey`, value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

export const deleteRandomApikey = createAsyncThunk('apiSetttings/deleteRandomApikey', async (id) => {
  try {
    const response = await axios.delete(`RandomKey/deleterandomapikey?id=${id}`);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});
//getRouteData
export const getRoutes = createAsyncThunk('apiSetttings/getRoutes', async () => {
  const response = await axios.get(`getRoute`);
  return response.data;
});
//updateRoute
export const updateRoutes = createAsyncThunk('apiSetttings/updateRoutes', async (value) => {
  try {
    const response = await axios.post(`route`, value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

const initialState = {
  data: [],
  loading: false,
  routeData: {
    apiRoute: 'restapi',
    apiInterface: false,
  },
  routeLoading: false,
};

const apiSetttings = createSlice({
  name: 'apiSetttings',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getRandomApikey.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRandomApikey.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getRandomApikey.rejected, (state) => {
        state.loading = false;
        state.data = [];
      })
      .addCase(getRoutes.pending, (state) => {
        state.routeLoading = true;
        state.routeData = initialState.routeData;
      })
      .addCase(getRoutes.fulfilled, (state, action) => {
        state.routeLoading = false;
        state.routeData = action.payload;
      })
      .addCase(getRoutes.rejected, (state) => {
        state.routeLoading = false;
        state.routeData = initialState.routeData;
      });
  },
});
export default apiSetttings.reducer;
